module.exports = __webpack_public_path__ + "img/github-icon.bbe9f9b8.svg";